export type PersonalityPreviewInput = {
  nome_do_agente?: string;
  nome_empresa?: string;
  personalidade_principal?: string;
  uso_de_emojis?: string;
};

export function buildPersonalityPreview({
  nome_do_agente,
  nome_empresa,
  personalidade_principal,
  uso_de_emojis,
}: PersonalityPreviewInput): string {
  const agentName = nome_do_agente || 'Ana';
  const restaurantName = nome_empresa || 'seu restaurante';
  const emoji = uso_de_emojis === 'Sempre usar'
    ? ' 😊🍽️'
    : uso_de_emojis === 'Usar ocasionalmente'
      ? ' 😊'
      : '';
  if (personalidade_principal === 'Amigável e informal') {
    return `Oi! Eu sou ${agentName}, do ${restaurantName}. Que bom te ver por aqui! O que você gostaria hoje?${emoji}`;
  }
  if (personalidade_principal === 'Profissional e objetivo') {
    return `Olá. Eu sou ${agentName}, assistente virtual do ${restaurantName}. Como posso ajudar?${emoji}`;
  }
  if (personalidade_principal === 'Próximo e descontraído') {
    return `Oi! Eu sou ${agentName}, do ${restaurantName}. Como posso te ajudar hoje?${emoji}`;
  }
  return `Olá! Eu sou ${agentName}, assistente virtual do ${restaurantName}. Como posso ajudar?${emoji}`;
}
